
export enum UserRoleEnum {
    MANAGER = 1,
    RECRUITER = 2,
    SCHEDULER = 3,
    CREDENTIALER = 4,
    ACCOUNTANT = 5,
    PROVIDER = 6,
    FACILITY_CONTACT = 7,
    TRAVEL_LOGISTICS = 9,
    OWNER = 10, // Owner doesn't grant any permissions in admin
    COMMUNICATIONS = 11,
    LICENSING = 12
}

export const allUserRoles = [
  UserRoleEnum.MANAGER,
  UserRoleEnum.RECRUITER,
  UserRoleEnum.SCHEDULER,
  UserRoleEnum.CREDENTIALER,
  UserRoleEnum.ACCOUNTANT,
  UserRoleEnum.PROVIDER,
  UserRoleEnum.FACILITY_CONTACT,
  UserRoleEnum.TRAVEL_LOGISTICS,
  UserRoleEnum.COMMUNICATIONS,
  UserRoleEnum.LICENSING
];

export const adminRoles = [
  UserRoleEnum.MANAGER,
  UserRoleEnum.RECRUITER,
  UserRoleEnum.SCHEDULER,
  UserRoleEnum.CREDENTIALER,
  UserRoleEnum.ACCOUNTANT,
  UserRoleEnum.TRAVEL_LOGISTICS,
  UserRoleEnum.COMMUNICATIONS,
  UserRoleEnum.LICENSING
];

export const credentialerRoles = [
  UserRoleEnum.MANAGER,
  UserRoleEnum.CREDENTIALER,
  UserRoleEnum.ACCOUNTANT,
];
const MANAGER_DESC = 'Manager';
const RECRUITER_DESC = 'Recruiter';
const SCHEDULER_DESC = 'Scheduler';
const CREDENTIALER_DESC = 'Credentialer';
const ACCOUNTANT_DESC = 'Accountant';
const PROVIDER_DESC = 'Provider';
const FACILITY_CONTACT = 'Facility Contact';
const TRAVEL_LOGISTICS_DESC = 'Travel Logistics';
const OWNER_DESC = 'Owner';
const COMMUNICATIONS_DESC = 'Communications';
const LICENSING_DESC = 'Licensing';

export function humanReadableRole(userRole: UserRoleEnum) : string {
  switch (userRole) {
    case UserRoleEnum.MANAGER:
      return MANAGER_DESC;
    case UserRoleEnum.RECRUITER:
      return RECRUITER_DESC;
    case UserRoleEnum.SCHEDULER:
      return SCHEDULER_DESC;
    case UserRoleEnum.CREDENTIALER:
      return CREDENTIALER_DESC;
    case UserRoleEnum.ACCOUNTANT:
      return ACCOUNTANT_DESC;
    case UserRoleEnum.PROVIDER:
      return PROVIDER_DESC;
    case UserRoleEnum.FACILITY_CONTACT:
      return FACILITY_CONTACT;
    case UserRoleEnum.TRAVEL_LOGISTICS:
      return TRAVEL_LOGISTICS_DESC;
    case UserRoleEnum.OWNER:
      return OWNER_DESC;
    case UserRoleEnum.COMMUNICATIONS:
      return COMMUNICATIONS_DESC;
    case UserRoleEnum.LICENSING:
      return LICENSING_DESC;
    default:
      return '';
  }
}

export const taskAssignGroups = [
  { appUserId: -UserRoleEnum.MANAGER, fullname: `Group - ${MANAGER_DESC}` },
  { appUserId: -UserRoleEnum.RECRUITER, fullname: `Group - ${RECRUITER_DESC}` },
  { appUserId: -UserRoleEnum.SCHEDULER, fullname: `Group - ${SCHEDULER_DESC}` },
  { appUserId: -UserRoleEnum.CREDENTIALER, fullname: `Group - ${CREDENTIALER_DESC}` },
  { appUserId: -UserRoleEnum.ACCOUNTANT, fullname: `Group - ${ACCOUNTANT_DESC}` },
  { appUserId: -UserRoleEnum.TRAVEL_LOGISTICS, fullname: `Group - ${TRAVEL_LOGISTICS_DESC}` },
  { appUserId: -UserRoleEnum.COMMUNICATIONS, fullname: `Group - ${COMMUNICATIONS_DESC}` },
  { appUserId: -UserRoleEnum.LICENSING, fullname: `Group - ${LICENSING_DESC}` },
];

// pretty garbage, but I'm not going to refactor advanced search at this time to use the same fields as the above task assign group
// list.  I'm moving it here so that if we add any other security roles in the future it's easy to remember to change in both places
export const taskAssignGroupsAdvancedSearch = [
  { id: -UserRoleEnum.MANAGER, name: `Group - ${MANAGER_DESC}` },
  { id: -UserRoleEnum.RECRUITER, name: `Group - ${RECRUITER_DESC}` },
  { id: -UserRoleEnum.SCHEDULER, name: `Group - ${SCHEDULER_DESC}` },
  { id: -UserRoleEnum.CREDENTIALER, name: `Group - ${CREDENTIALER_DESC}` },
  { id: -UserRoleEnum.ACCOUNTANT, name: `Group - ${ACCOUNTANT_DESC}` },
  { id: -UserRoleEnum.TRAVEL_LOGISTICS, name: `Group - ${TRAVEL_LOGISTICS_DESC}` },
  { id: -UserRoleEnum.COMMUNICATIONS, name: `Group - ${COMMUNICATIONS_DESC}` },
  { id: -UserRoleEnum.LICENSING, name: `Group - ${LICENSING_DESC}` },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/userRolesEnum.ts